module.exports = __webpack_public_path__ + "static/img/fish15.633eaf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish15.png
// module id = 9zS+
// module chunks = 0